import { CardStore } from '@intelingu/core/stores/CardStore';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { config } from 'config';
import { autobind } from 'core-decorators';
import { action, computed, observable, reaction, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { lazyInject } from '@intelingu/core/IoC/container';
import Modal from 'react-modal';

interface FinishedLegModalProps {
}

@observer export class FinishedLegModal extends Component<FinishedLegModalProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;
    @lazyInject(UserStore) userStore: UserStore;

    reaction;
    fixedCard;
    audioSuccessRef;

    @computed get isActive() {
        return this.cardStore.isLegAchievementActive;
    }

    set isActive(value) {
        runInAction(() => {
            this.cardStore.isLegAchievementActive = value;
        });
    }

    @action.bound ok() {
        this.isActive = false;
    }

    componentDidMount(): void {
        this.reaction = reaction(() => this.cardStore.showLegAchievement, this.showReaction)
    }

    @autobind showReaction() {
        if (this.cardStore.showLegAchievement) {
            this.cardStore.showLegAchievement = false;

            /*if (this.audioSuccessRef) {
                this.audioSuccessRef.currentTime = 0;
                this.audioSuccessRef.play();
            }*/

            this.isActive = true;

            this.userStore.loadProgress();
        }
    }

    componentWillMount(): void {
        this.reaction && this.reaction();
    }

    render() {
        return <>
            {/*<div className={'hidden'}>
                <audio ref={elm => this.audioSuccessRef = elm}
                       className={'invisible-audio'}
                       autoPlay={false}
                       controls>
                    <source src={require(`assets/sounds/leg-finished.mp3`)} />
                </audio>
            </div>*/}

            { this.isActive && (
                <Modal isOpen={true}
                       overlayClassName={'modal-overlay'}
                       ariaHideApp={false}
                       shouldCloseOnOverlayClick={true}
                       onRequestClose={this.ok}
                       className={'progress-bar-achievement'}>

                    <div className={'achievement custom'}>
                        <div className={'bg'} style={{ background: `url(${this.userStore.progress.leg.image_finished || require('assets/images/pb-congrat-leg.jpg')})` }}>
                            <div className={'content'} />
                        </div>

                        <a href={''} className={'close'} onClick={e => {
                            e.preventDefault();
                            this.ok();
                        }}>
                            <i className="icon ion-md-close" />
                        </a>
                    </div>
                </Modal>
            )}
        </>
    }

}
